/**
 * O que se sabe do setor escolhido antes de o posto ser salvo (`GET /departments/:id/context`):
 * funcionários ativos (só referência) e se há medição de conforto. Carregando ou falha nunca travam o
 * cadastro: quem usa mostra uma frase curta e segue.
 */
import { useEffect, useState } from 'react';
import { ergonomicWorkstationService } from '../../../../services/ergonomicWorkstationService';
import type { ErgonomicDepartmentContext } from '../../../../types/ergonomicWorkstation';

export type DepartmentContextState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'ready'; context: ErgonomicDepartmentContext };

export function useDepartmentContext(departmentId: string, companyId: string): DepartmentContextState {
  const [state, setState] = useState<DepartmentContextState>({ status: 'idle' });

  useEffect(() => {
    if (departmentId === '') {
      setState({ status: 'idle' });
      return undefined;
    }
    let alive = true;
    setState({ status: 'loading' });
    ergonomicWorkstationService
      .departmentContext(departmentId, companyId === '' ? undefined : companyId)
      .then((context) => alive && setState({ status: 'ready', context }))
      .catch(() => alive && setState({ status: 'error' }));
    return () => {
      alive = false;
    };
  }, [departmentId, companyId]);

  return state;
}
